import React, { useState } from "react";
import { Paper, Box, TextField, Button, Chip, IconButton, Menu, MenuItem } from "@mui/material";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import SaveIcon from "@mui/icons-material/Save";
import CanvasSizeDialog from "./CanvasSizeDialog";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function EditorTopBar({
    title,
    setTitle,
    canvasSize,
    setCanvasSize,
    onSave,
    onCreateNew,
    onDelete,
    mode,
    isSaving = false,
}) {
    const [sizeDialogOpen, setSizeDialogOpen] = useState(false);
    const [menuAnchor, setMenuAnchor] = useState(null);
    const navigate = useNavigate();

    const handleMenuOpen = (event) => {
        setMenuAnchor(event.currentTarget);
    }
    const handleMenuClose = () => {
        setMenuAnchor(null);
    }

    const handleCreateNew = async () => {
        handleMenuClose();
        if (!onCreateNew) return;
        await onCreateNew();
    };

    const handleDelete = async () => {
        handleMenuClose();
        if (!onDelete) return;
        await onDelete();
    };

    const modeLabel = mode === "model" ? "Modèle" : "Design";
    const modeColor = mode === "model" ? "primary" : "secondary";

    return (
        <>
            <Paper
                elevation={2}
                square
                sx={{ display: "flex", alignItems: "center", px: 2, py: 1, gap: 2, zIndex: 10, flexShrink: 0 }}
            >

                <IconButton onClick={handleMenuOpen}>
                    <MenuIcon/>
                </IconButton>
                <Menu
                    anchorEl={menuAnchor}
                    open={Boolean(menuAnchor)}
                    onClose={handleMenuClose}
                >
                    <MenuItem onClick={handleCreateNew} disabled={!onCreateNew || isSaving}>Créer un nouveau {modeLabel}</MenuItem>
                    <MenuItem onClick={handleDelete} disabled={!onDelete || isSaving}>Supprimer</MenuItem>
                    <MenuItem onClick={() => navigate(-1)}>Quitter</MenuItem>
                </Menu>

                <Chip label={modeLabel} size="small" color={modeColor} />

                <TextField
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    variant="standard"
                    size="small"
                    sx={{ minWidth: 220 }}
                    inputProps={{ style: { fontSize: 17, fontWeight: 700 } }}
                />

                <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }} >
                    {/* <IconButton disabled={window.history.length <= 1} onClick={()=>window.history.back}>
                        <Undo/>
                    </IconButton>
                    <IconButton disabled>
                        <Redo/>
                    </IconButton> */}
                </Box>

                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<AspectRatioIcon />}
                    onClick={() => setSizeDialogOpen(true)}
                >
                    {canvasSize.width} × {canvasSize.height} px
                </Button>

                <Button
                    variant="contained"
                    size="small"
                    startIcon={<SaveIcon />}
                    disabled={isSaving}
                    onClick={onSave}
                >
                    {isSaving ? "Sauvegarde..." : "Sauvegarder"}
                </Button>
            </Paper>

            <CanvasSizeDialog
                open={sizeDialogOpen}
                currentSize={canvasSize}
                onClose={() => setSizeDialogOpen(false)}
                onApply={(size) => { setCanvasSize(size); setSizeDialogOpen(false); }}
            />
        </>
    );
}
